module.exports = __webpack_public_path__ + "img/analysis-income-statement.7460283e.svg";